import { useGlobalHonoClient } from "~/hooks/HonoContext";
import { useGetObjectAccessToken } from "~/hooks/useGetObjectAccessToken";

export const useGetR2AssetURL = () => {
  const { globalHc } = useGlobalHonoClient();
  const { data } = useGetObjectAccessToken({ enabled: true });

  return {
    getR2AssetURL: (r2Key: string) => {
      const url = globalHc.object.$url();

      // TODO: this will void the http-header caching cuz token keeps changing....
      // find a way to fix this with a proxy?
      url.searchParams.set(
        "token",
        encodeURIComponent(data?.data?.accessToken ?? ""),
      );
      url.searchParams.set("key", encodeURIComponent(r2Key));
      url.searchParams.set("belongsTo", "save");

      return url.toString();
    },
  };
};
